<template>
 <p class="text-5xl text-center mb-2">🗂️</p>
  <h2 class="text-3xl font-bold leading-10 text-gray-900 text-center">
    {{ $t(`Trial manager`) }}
  </h2>
  <p class="mx-auto max-w-md text-base text-center text-gray-500">
    {{ $t(`See a list of the features your account doesn't have access to below. Find out more & test each feature for 7 days.`) }}
  </p>
</template>
